var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',_vm._g(_vm._b({staticClass:"alert font-weight-bold",attrs:{"icon":_vm.icon || false,"color":_vm.color,"text":"","outlined":""}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }